export const MAP = {
    prs: {
        required: ':name الزامی است.',
        minLength5: 'حداقل دارای پنچ حرف باید باشد.',
        emailPattern: 'لطفا ایمل درست وارد نمایید.',
        onlyText: 'لطفا فقط حروف وارد نمایید.',
        phoneNumberAfg: 'لطفا شماره ی تماس را به شکل 93xxxxxxxxx وارد نمایید.',
        generalPhoneNumber: 'لطفا شماره ی تماس داخل افغانستان را به شکل 937xxxxxxxx و یا 932xxxxxxxx وارد نمایید.',
        phoneNumberInternational: 'لطفا شماره ی تماس بین المللی را همراه با کود کشور وارد نمایید، بطور مثال (14155552671 - شماره تماس آمریکا).',
        integer: 'لطفا اعداد بدون اعشاریه وارد نمایید.',
        year: 'لطفا سال مالی را به شکل xxxx وارد نمایید.',
    },
    ps: {
        required: ':name الزامی دی.',
        minLength5: 'حداقل دارای پنچ حرف باید باشد.',
        emailPattern: 'لطفا ایمل درست وارد نمایید.',
        onlyText: 'لطفا فقط حروف وارد نمایید.',
        phoneNumberAfg: 'لطفا شماره ی تماس را به شکل 93xxxxxxxxx وارد نمایید.',
        generalPhoneNumber: 'لطفا شماره ی تماس داخل افغانستان را به شکل 937xxxxxxxx و یا 932xxxxxxxx وارد نمایید.',
        phoneNumberInternational: 'Please provide the international phone number, e.g. 14155552671 (US phone number).',
        integer: 'لطفا اعداد بدون اعشاریه وارد نمایید.',
        year: 'لطفا سال مالی را به شکل xxxx وارد نمایید.',
    },
    en: {
        required: ':name is required.',
        minLength5: 'Should be at least five characters.',
        emailPattern: 'Please enter a correct email address.',
        onlyText: 'Please enter alphabets only.',
        phoneNumberAfg: 'Please provide the contact number as 93xxxxxxxxx .',
        generalPhoneNumber: 'Please provide Afghanistan contact number as 937xxxxxxxx or 932xxxxxxxx .',
        phoneNumberInternational: 'Please provide the international phone number with country code (14155552671 - US phone number).',
        integer: 'Please provide whole number.',
        year: 'Please provide fiscal year as xxxx.',
    },
};

